import {Button, Dialog, DialogActions, DialogContent, Typography} from "@mui/material";
import BaseDialogTitle from "./BaseDialogTitle";
import DeleteIcon from "@mui/icons-material/Delete";

interface DeleteDialogProps {
    open: boolean,
    onClose: () => void,
    title?: string,
    description?: string,
    onDelete: () => void
}


const DeleteDialog = ({open, onClose, title, description, onDelete}: DeleteDialogProps) => {
    
    const handleDelete = () => {
        onDelete()
        onClose()
    }
    
    return (
        <Dialog open={open}
                onClose={onClose}
                maxWidth={'sm'}
                fullWidth
        >
            <BaseDialogTitle onClose={onClose} title={title}/>
            <DialogContent>
                <Typography>{description}</Typography>
            </DialogContent>
            <DialogActions>
                <Button startIcon={<DeleteIcon/>} color={'primary'} variant={'contained'} onClick={handleDelete}>Eliminar</Button>
            </DialogActions>
        </Dialog>
                
    )
}


export default DeleteDialog